import { isSameDay as n } from "../../node_modules/date-fns/isSameDay.js";
import { endOfDay as u } from "../../node_modules/date-fns/endOfDay.js";
import { isPast as f } from "../../node_modules/date-fns/isPast.js";
const m = (e, t) => t?.some((r) => n(new Date(r), e)), y = (e, t) => !t || t.length === 0 ? !1 : t.some((r) => n(new Date(r), e));
function p(e) {
  const t = u(e);
  return f(t);
}
const d = (e) => `${e.slice(0, 1).toUpperCase()}${e.slice(1)}`, g = (e, t, r, a, i, s, o) => i ? o ? "startDateRange" : "selectedDay" : s ? "endDateRange" : e ? "selectedDay" : a ? "isSelectedRangeDay" : t ? "currentDay" : r ? "outSideMonth" : "normal", h = (e, t) => e ? "selectedDay" : t ? "currentDay" : "normal";
export {
  d as firstLetterUpperCase,
  g as getDateCellVariant,
  h as getWeekCellVariant,
  p as hasDatePassed,
  y as hasDotOnDate,
  m as isDateStrikeThrough
};
